export default "__VITE_ASSET__Duer$hYU__"